import React from "react";

const Home = () => {
  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold text-blue-600">Welcome to BengSports!</h1>
      <p className="text-lg mt-4 text-gray-700">
        Your go-to directory for sports stadiums, food, and game-day experiences.
      </p>
    </div>
  );
};

export default Home;
